export default "__VITE_ASSET__BmN615bx__"